import { forwardRef } from "react";

const TextInputField = forwardRef(
  (
    {
      value,
      onChange,
      placeholder = "Enter text...",
      disabled = false,
      width,
      style = {},
      onFocus,
      onBlur,
      onMouseOver,
      onMouseOut,
      className = "",
      ...props
    },
    ref
  ) => {
    const baseStyle = {
      width,
      background: "#111",
      border: "1px solid #444",
      borderRadius: 4,
      padding: "7px 10px",
      color: "#fff",
      fontSize: 16,
      outline: "none",
      fontFamily: '"Segoe UI", sans-serif',
      transition: "border-color 0.15s ease",
    };

    const handleFocus = (e) => {
      e.target.style.borderColor = "#666";
      onFocus?.(e);
    };

    const handleBlur = (e) => {
      e.target.style.borderColor = "#444";
      onBlur?.(e);
    };

    const handleMouseOver = (e) => {
      e.target.style.borderColor = "#999";
      onMouseOver?.(e);
    };

    const handleMouseOut = (e) => {
      e.target.style.borderColor = "#444";
      onMouseOut?.(e);
    };

    return (
      <>
        <style>{`
        .text-input-field::placeholder {
        color: #888;
        }
  `}</style>
        <input
          ref={ref}
          type={"text"}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          className={`text-input-field ${className}`}
          style={{ ...baseStyle, ...style }}
          {...props}
        />
      </>
    );
  }
);

export default TextInputField;
